export const defaultContactTag = "egwweb";
export const paraPictureRegExp = /<a\s+(?:[^>]*?\s+)?href=(["'])(.*?)\1/;
export const emailRegExp = /^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+\.[A-Za-z]+$/;
export const fileFormatRegex = /(.*?)\.(docx|doc|pdf|xml|bmp|ppt|xls|txt|log|mp4|mov|wmv|flv|avi|mkv|jpeg|jpg|png)$/;
export const MAX_FILE_SIZE = 10000000;

export const initValues = {
  domain: "main",
  lang: "en",
  contact: "",
  name: "",
  email: "",
  message: "",
};
export const initErrors = {
  contact: "",
  name: "",
  email: "",
  message: "",
};
